import React, {useEffect} from "react";
import {JsGrid, useJsGridToolbar} from "@bavuchoko/js-grid";
import {isMobile} from "../commonmethod/CommonMethod";
import {useMobileViewport} from "../../hooks/useMobileViewport";
import SimmsListThumbView from "./SimmsListThumbView";

/** JsGrid 본문 로딩 오버레이 — toolbarEnd 슬롯 안에서만 사용 */
export function JsGridBodyLoadingOverlay({loading, label = "불러오는 중…"}) {
    const toolbarApi = useJsGridToolbar();

    useEffect(() => {
        if (!toolbarApi) return;
        if (loading) {
            toolbarApi.setBodyOverlay({label, accent: "#2563eb"});
        } else {
            toolbarApi.setBodyOverlay(null);
        }
        return () => toolbarApi.setBodyOverlay(null);
    }, [toolbarApi, loading, label]);

    return null;
}

function mergeToolbarEnd(toolbarEnd, loading, loadingLabel) {
    return (api) => (
        <>
            <JsGridBodyLoadingOverlay loading={loading} label={loadingLabel} />
            {toolbarEnd == null ? null : typeof toolbarEnd === "function" ? toolbarEnd(api) : toolbarEnd}
        </>
    );
}

/**
 * JsGrid + 데이터 조회 로딩 오버레이
 * 모바일(기기·768px 이하)에서는 JsGrid 대신 썸네일 카드 목록 표시
 * @param {boolean} [loading=false]
 * @param {string} [loadingLabel]
 * @param {boolean} [mobileThumb=true] — false 이면 모바일에서도 JsGrid 유지
 */
function SimmsJsGrid({
    loading = false,
    loadingLabel,
    toolbarEnd,
    mobileThumb = true,
    data,
    header,
    onRowClick,
    onPageChange,
    style,
    ...props
}) {
    const isMobileViewport = useMobileViewport();
    const useThumbList = mobileThumb !== false && (isMobile || isMobileViewport);

    if (useThumbList) {
        return (
            <SimmsListThumbView
                data={data}
                header={header}
                onRowClick={onRowClick}
                onPageChange={onPageChange}
                loading={loading}
            />
        );
    }

    return (
        <JsGrid
            {...props}
            data={data}
            header={header}
            onRowClick={onRowClick}
            onPageChange={onPageChange}
            style={style}
            toolbarEnd={mergeToolbarEnd(toolbarEnd, loading, loadingLabel)}
        />
    );
}

export default SimmsJsGrid;
